import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";
import { createObj } from "../Docs/fable_modules/fable-library.3.7.1/Util.js";
import { singleton } from "../Docs/fable_modules/fable-library.3.7.1/List.js";

export class Column {
    constructor() {
    }
}

export function Column$reflection() {
    return class_type("Feliz.TanStack.Table.Visibility.Column", void 0, Column);
}

export function Column_getCanHide_Z2685F962(column) {
    return column.getCanHide();
}

export function Column_getIsVisible_Z2685F962(column) {
    return column.getIsVisible();
}

export function Column_toggleVisibility_Z2685F962(column) {
    column.toggleVisibility();
}

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Visibility.Table", void 0, Table);
}

export function Table_getVisibleFlatColumns_Z4395D14A(table) {
    return table._obj.getVisibleFlatColumns();
}

export function Table_getVisibleLeafColumns_Z4395D14A(table) {
    return table._obj.getVisibleLeafColumns();
}

export function Table_getLeftVisibleLeafColumns_Z4395D14A(table) {
    return table._obj.getLeftVisibleLeafColumns();
}

export function Table_getRightVisibleLeafColumns_Z4395D14A(table) {
    return table._obj.getRightVisibleLeafColumns();
}

export function Table_getCenterVisibleLeafColumns_Z4395D14A(table) {
    return table._obj.getCenterVisibleLeafColumns();
}

export function Table_setColumnVisibility(column, isVisible, table) {
    const r = createObj(singleton([column.id, isVisible]));
    table._obj.setColumnVisibility(r);
    return table;
}

export function Table_resetColumnVisibility(defaultState, table) {
    table._obj.resetColumnVisibility(defaultState);
    return table;
}

export function Table_toggleAllColumnsVisible(value, table) {
    table._obj.toggleAllColumnsVisible(value);
    return table;
}

export function Table_getIsAllColumnsVisible_Z4395D14A(table) {
    return table._obj.getIsAllColumnsVisible();
}

export function Table_getIsSomeColumnsVisible_Z4395D14A(table) {
    return table._obj.getIsSomeColumnsVisible();
}

//# sourceMappingURL=Visibility.fs.js.map
